module.exports = __webpack_public_path__ + "img/CM-BS-24-CJDR-Playful.dd0f6bbc.jpg";